// extracted by mini-css-extract-plugin
export default {"root":"ListingConcludedBanner_root__e5K-9","title":"ListingConcludedBanner_title__qz1Sn h3","body":"ListingConcludedBanner_body__7rV7s"};